import React, { useCallback, useEffect, useState } from "react";
import $ from "jquery";
import { Link } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import BuddibleSocket from "../../../lib/BuddibleSocket";
import Utilities from "../../../lib/Utilities";
import { useTranslation } from "react-i18next";

const socket = new BuddibleSocket();
const util = new Utilities();

window.jQuery = $;
window.$ = $;
global.jQuery = $;

let rowsPerPage = 10;
let page = 0;
let slideCountBackUp = 5;
export default function ShipCompNotice() {
  const [slideCount, setSlideCount] = useState(5);
  const [serverData, setServerData] = useState([]);
  const { t } = useTranslation();

  $(document).ready(function () {
    $(".custom-owl-nav-main").empty();
    $(".custom-owl-nav-main").on("click", changeOwlStyle);
    $(".custom-owl-nav-main.prev").click();
    $(".custom-owl-nav-main.prev").click();
    $("#post-content p, span, strong").css({ color: "inherit" });
  });

  useEffect(() => {
    SELECT_SHIP_COMP_NOTICE();
    handleSlideCount();
    window.addEventListener("resize", handleSlideCount);
    window.addEventListener("resize", changeOwlStyle);
    return () => {
      window.removeEventListener("resize", handleSlideCount);
      window.removeEventListener("resize", changeOwlStyle);
    };
  }, []);

  function handleSlideCount() {
    let windowWidth = window.innerWidth;
    if (windowWidth < 576) {
      slideCountBackUp = 1;
      //  mobile
    } else if (windowWidth >= 576 && windowWidth < 1200) {
      slideCountBackUp = 3;
    } else {
      slideCountBackUp = 5;
    }
    setSlideCount(slideCountBackUp);
  }

  function changeOwlStyle() {
    let eqIndex = 2;
    let calcValuePrev = "62.5%";
    let calcValueNext = "62% ";
    if (slideCountBackUp === 1) {
      eqIndex = 0;
      calcValuePrev = "100%";
      calcValueNext = "100%";
    } else if (slideCountBackUp === 3) {
      eqIndex = 1;
      calcValuePrev = "71.5%";
      calcValueNext = "70%";
    }

    $(".owl-item").css({
      zIndex: 0,
      transform: "unset",
      transition: "unset",
      maxHeight: 300,
      opacity: 0.8,
    });
    $(".owl-item.active .post-card").removeClass(
      "bg-freiscop text-white shadow-lg"
    );
    $(".owl-item.active .post-title").addClass("text-dark shadow-sm");
    $(".owl-item.active")
      .eq(eqIndex)
      .css({
        zIndex: 2,
        transform: window.innerWidth > 575 ? "scale(1.25)" : "",
        transition: "transform 0.3s ease",
        maxHeight: "unset",
        opacity: 1,
      });
    $(".owl-item.active .post-card").eq(eqIndex).removeClass("shadow-sm");
    $(".owl-item.active .post-card")
      .eq(eqIndex)
      .addClass("bg-freiscop text-white shadow-lg");
    $(".owl-item.active .post-title").eq(eqIndex).removeClass("text-dark");
    $(".owl-item.active .post-title")
      .eq(eqIndex)
      .addClass("bg-freiscop text-white");
    $(".custom-owl-nav-main.prev").css({
      right: `calc(${calcValuePrev})`,
    });
    $(".custom-owl-nav-main.next").css({
      left: `calc(${calcValueNext})`,
    });
  }

  function SELECT_SHIP_COMP_NOTICE(SEARCH_WORD) {
    let msgID = util.makeUUIDv4();
    let socketMsg = {
      file: "/logistoryBoard/JS_mainLogistorySelect.php",
      msgID: msgID,
      data: {},
      take: rowsPerPage,
      skip: page * rowsPerPage,
      page: page + 1,
      pageSize: 5,
      SEARCH_WORD: SEARCH_WORD,
      TRANS_TYPE: "",
      sort: [
        {
          field: "prCreateDate",
          dir: "desc",
        },
      ],
    };

    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        if (newData["ret"]) {
          setServerData(newData["returnData"]);
        }
      }
    });
  }

  const PostItemRender = useCallback((params) => {
    return <PostItem {...params} />;
  }, []);
  const PostItem = useCallback(
    React.memo((params) => {
      const item = { ...params };

      let hash = "";
      for (let key in item) {
        if (key.indexOf("IDX") > -1) {
          hash = item[key];
        }
      }

      let prLOGO;
      if (item.prLOGO) {
        prLOGO = item.prLOGO.split("?")[0];
      }

      return (
        <>
          <div className="p-2">
            <div
              className="post-card transition-2 bg-white shadow-sm rounded p-2 overflow-hidden"
              style={{ maxHeight: 300 }}
            >
              <Link
                to={`/PostDetail/carrierNotice/${hash}`}
                className="post-title flex-grow-1 text-dark"
              >
                <div className="p-2 border-bottom">
                  <div className="d-flex flex-row align-items-center justify-content-between mb-2">
                    <div className="d-flex flex-row align-items-center ">
                      <div
                        className="mr-2 rounded"
                        style={{
                          minWidth: 25,
                          width: 25,
                          height: 25,
                          background: `url(${prLOGO})50% 50%/contain rgb(250,250,250) no-repeat`,
                        }}
                      >
                        {!prLOGO && (
                          <div className="w-100 h-100 rounded bg-light d-flex flex-row justify-content-center align-items-center">
                            <span>LOGO</span>
                          </div>
                        )}
                      </div>
                      <p className="m-0 mr-2" style={{ minWidth: 100 }}>
                        {item.prBCOMPNM || t("main.shipCompNotice.compName")}
                      </p>
                    </div>
                    <p className="m-0 font-weight-bold">
                      {item.prCreateDate.split(" ")[0]}
                    </p>
                  </div>

                  <p className="w-100 m-0" style={{ maxWidth: 600 }}>
                    {item.prTITLE.trim()}
                  </p>
                </div>
                <div
                  id="post-content"
                  className="p-2 text-truncate overflow-hidden font-size-08"
                  style={{ height: 250, maxHeight: 250 }}
                  dangerouslySetInnerHTML={{ __html: item.prCONTENTS }}
                />
              </Link>
            </div>
          </div>
        </>
      );
    })
  );
  return (
    <div className="py-5" id="ship-comp-notice">
      <div className="margin_30">
        <div className="row m-0">
          <div className="col-12 text-center mb-sm-5">
            <div className="h4 font-weight-bold">
              {t("main.shipCompNotice.title")}
            </div>
            <div className="text-secondary">
              {t("main.shipCompNotice.description")}
            </div>
          </div>

          <div className="col-12 m-0 my-3 my-sm-4 p-0">
            {serverData.length > 0 && (
              <OwlCarousel
                className="owl-theme"
                loop={true}
                nav={true}
                dots={false}
                autoplay={false}
                autoplayTimeout={2500}
                autoplayHoverPause={true}
                items={slideCount}
                navContainerClass="d-flex flex-row justify-content-center"
                navClass={[
                  "custom-owl-nav-main prev h1 font-weight-900 mb-0 fa-solid fa-angle-left",
                  "custom-owl-nav-main next h1 font-weight-900 mb-0 fa-solid fa-angle-right",
                ]}
              >
                {serverData.map((item, index) => {
                  return <PostItemRender {...item} key={index} />;
                })}
              </OwlCarousel>
            )}
          </div>
          <div className="col-12 text-center mt-sm-5">
            <Link
              to="/PostList/carrierNotice"
              className="text-secondary h6 hover_point cursor_pointer_fw_bold transition-2"
            >
              {t("main.shipCompNotice.viewMore")}{" "}
              <i className="fa-solid fa-arrow-right"></i>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
